import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { IButtonDirective } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { OnboardingService } from "@m19-board/services/onboarding.service";

@Component({
  selector: "app-product-tour-cta",
  imports: [TranslocoDirective, IButtonDirective],
  host: { class: "flex gap-2" },
  template: `
    <ng-container *transloco="let t">
      <button iButton size="sm" (click)="upgrade()">{{ t("product-tour.upgrade_to_pro") }}</button>
    </ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductTourCtaComponent {
  private readonly onboardingService = inject(OnboardingService);

  protected upgrade(): void {
    this.onboardingService.upgradeFromProductTour();
  }
}
